// extracted by mini-css-extract-plugin
module.exports = {"help-message":"file-download_component_help-message__wbhrl","card":"file-download_component_card__KmbPb","card-img-top":"file-download_component_card-img-top__N0rfd"};